export * from "src/generated/hooks/form-service/requests/types.gen";

export const SectionTypes = {
  PreRankingSection: "PreRankingSection",
  SchoolRankingSection: "SchoolRankingSection",
  DisclaimerSection: "DisclaimerSection",
  GeneralSection: "GeneralSection",
} as const;

export const SectionTypeList = [
  SectionTypes.PreRankingSection,
  SectionTypes.SchoolRankingSection,
  SectionTypes.GeneralSection,
  SectionTypes.DisclaimerSection,
] as const;

export const QuestionTypes = {
  SingleSelect: "SingleSelect",
  MultiSelect: "MultiSelect",
  FreeText: "FreeText",
  FileUpload: "FileUpload",
  Grades: "Grades",
  Email: "Email",
  PhoneNumber: "PhoneNumber",
  Address: "Address",
  CustomQuestion: "CustomQuestion",
  Date: "Date",
  Number: "Number",
} as const;

export const QuestionTypeList = [
  QuestionTypes.SingleSelect,
  QuestionTypes.MultiSelect,
  QuestionTypes.FreeText,
  QuestionTypes.FileUpload,
  QuestionTypes.Grades,
  QuestionTypes.Email,
  QuestionTypes.PhoneNumber,
  QuestionTypes.Address,
  QuestionTypes.CustomQuestion,
  QuestionTypes.Date,
  QuestionTypes.Number,
] as const;
